import React, {useCallback, useEffect, useLayoutEffect, useState} from 'react';
import {Layout, Space} from 'antd';
import s from './PersonalAccount.module.css'
import logo from '../../assets/img/personalAccount/logo.svg'
import icon_close_circle from '../../assets/img/personalAccount/close-circle.svg'
import notify from '../../assets/img/personalAccount/info-circle.svg'
import plus from '../../assets/img/personalAccount/plus_black.svg'
import {Link, NavLink, Outlet, useLocation, useNavigate} from 'react-router-dom';
import '../../components/SideMenu/index.css'
import classnames from "classnames";
import {useAppDispatch, useAppSelector} from "../../hooks/redux";
import {
    createNewTypeOfAccountThunk, GetAccountsListThunk,
    GetAccountDetailsByAccountTypeThunk,
    getUserAccountListThunk,
    LogoutThunk, refreshTokenThunk, setAccountsListTypesThunk, setChosenAccountTypeIdThunk,
    setTokenState, GetLimitsListThunk,
} from "../../store/reducers/ActionCreators";
import {motion} from 'framer-motion';
import MyBtn from "../../components/ui/MyBtn/MyBtn";
import CustomModal from "../../components/ui/CustomModal/CustomModal";
import styles from "../../components/ContactUsForm/ContactUsForm.module.css";
import styles_popup from "../../styles/styles.module.css";
import SideMenu from "../../components/SideMenu/SideMenu";
import CustomModalContactContainer from "../../components/ui/CustomModalContactContainer/CustomModalContactContainer";
import CustomCheckbox from "../../components/ui/customCheckbox/CustomCheckbox";
import useOutsideClick from "../../hooks/useOutsideClick";
import MyInput from "../../components/ui/MyInput/MyInput";
import CustomCheckbox1 from "../../components/ui/CustomCheckbox1/CustomCheckbox1";
import TransparentButton from "../../components/ui/TransparentButton/TransparentButton";
import Icon from "@ant-design/icons";
import {ReactComponent as Back} from '../../assets/img/personalAccount/back.svg'
import {useFormik} from "formik";
import * as Yup from "yup";
import axios from "axios";
import {setDisabled, setIsLoading, setTokenRefresh, userSlice} from '../../store/reducers/UserSlice';
import {Loader} from '../../components/Loader/Loader';
import BugReport from "../../components/BugReport/BugReport";
import {Helmet} from "react-helmet-async";
import {DEACTIVATED_USER_PAGE} from "../../Constants/RoutesConstants";

const {Header, Sider, Content} = Layout;

const headerStyle: React.CSSProperties = {
    color: '#fff',
    height: "auto",
    backgroundColor: 'transparent',
    margin: '48px 24px 36px 264px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0'
};

const contentStyleMobile: React.CSSProperties = {
    minHeight: '100vh',
    color: '#000',
    backgroundColor: '#F6F6F6',
    padding: '0 16px 16px 16px',
};

const siderStyle: React.CSSProperties = {
    position: 'fixed',
    textAlign: 'center',
    color: '#fff',
    backgroundColor: '#0E492E',
    flex: '0 0 240',
    borderRight: '1.5px solid #EEEFEF',
    zIndex: 1,
    padding: '56px 0 56px 48px',
    height: '100vh',
    overflow: "auto"
};

const validationSchema = Yup.object({
    firstName: Yup.string().test({
        message: 'First Name is required',
        test: function (value) {
            const {companyName} = this.parent;
            if (!companyName) return value !== undefined && value !== null && value !== '';
            return true
        },
    }),
    lastName: Yup.string().test({
        message: 'Last Name is required',
        test: function (value) {
            const {companyName} = this.parent;
            if (!companyName) return value !== undefined && value !== null && value !== '';
            return true
        },
    }),
    companyName: Yup.string().test({
        message: 'Company Name is required',
        test: function (value) {
            const {lastName, firstName} = this.parent;
            if (!lastName && !firstName) return value !== undefined && value !== null && value !== '';
            return true
        },
    }),
    type: Yup.string()
});

const PersonalAccount = () => {

    const accType: string | null = useAppSelector(state => state.userReducer.user.userData.accountType)
    const accTypeList = useAppSelector(state => state.userReducer.accountTypesList)
    const chosenAccountTypeId = useAppSelector(state => state.userReducer.chosenAccountTypeId)
    const clientId: string | null = useAppSelector(state => state.userReducer.user.userData.clientId)
    const firstName: string | null = useAppSelector(state => state.userReducer.user.userData.firstName)
    const lastName: string | null = useAppSelector(state => state.userReducer.user.userData.lastName)
    const companyName: string | null = useAppSelector(state => state.userReducer.user.userData.companyName)
    const isTokenValid: boolean = useAppSelector(state => state.userReducer.tokenIsValid)
    const location = useLocation();

    const refreshToken = useAppSelector(state => state.userReducer.timeForRefresh)

    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState<boolean | null>(false)
    const [isDocumentErrorModalOpen, setIsDocumentErrorModalOpen] = useState<boolean | null>(false)
    const [documentErrorModalText, setDocumentErrorModalText] = useState<string | null>('')
    const [isBugReportPopupActive, setIsBugReportPopupActive] = useState<boolean | null>(false)
    const [isMenuShow, setIsMenuShow] = useState<boolean | null>(false)
    const [isModalForCreatingPersonalOpen, setIsModalForCreatingPersonalOpen] = useState(false)
    const [isErrorPopupOpen, setIsErrorPopupOpen] = useState<boolean | null>(false)
    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState<boolean | null>(false)
    const [isSuccessRefreshTokenPopupOpen, setIsSuccessRefreshTokenPopUp] = useState<boolean | null>(false)
    const [IsOpenPopupTokenRefresh, setIsOpenPopupTokenRefresh] = useState<boolean | null>(false)
    const [isSetRefreshToken, setIsSetRefreshToken] = useState(
        {
            userToken: '',
            sessionId: ''
        }
    )
    const [isModalForCreatingBusinessOpen, setIsModalForCreatingBusinessOpen] = useState(false)
    const [isInactiveMoreThanThirtyMinutes, setIsInactiveMoreThanThirtyMinutes] = useState(false)
    const [isIpWasChanged, setIsIpWasChanged] = useState(false)
    const {ref, ref2, isActive, setIsActive} = useOutsideClick(false);
    const dispatch = useAppDispatch()
    const [checkboxState, setCheckboxState] = useState({
        checkbox1: false,
        checkbox2: false,
    });
    // const [currentIp, setCurrentIp] = useState('');
    const sessionId = useAppSelector(store => store.userReducer.sessionId)
    const token = useAppSelector(state => state.userReducer.userToken)
    const kycVerificationStatus = useAppSelector(state => state.userReducer.user.flags.kycVerificationStatus)
    const kycFormStatus = useAppSelector(state => state.userReducer.user.flags.kycFormStatus)
    const accountId = useAppSelector(state => state.userReducer.chosenAccountTypeId)
    const isLogOutWhenUserWasInactive: boolean | undefined = useAppSelector(state => state.userReducer.user.flags.autoLogout)
    const isLogOutWhenIpWasChanged: boolean | undefined = useAppSelector(state => state.userReducer.user.flags.logoutIfIpChanges)

    const isLoading: boolean = useAppSelector(state => state.userReducer.isLoading)

    const [isMobile, setIsMobile] = useState(false)

    const [isContentHidden, setIsContentHidden] = useState(false)

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const handleLogout = useCallback(() => {
        dispatch({type: 'STOP_REFRESH_TIMER'});
        dispatch(setTokenRefresh(false))
        dispatch(LogoutThunk(sessionId, timezone, token))
            .then(() => {
                navigate("/login");
            })
    }, [dispatch, navigate, sessionId, token])

    useEffect(() => {

        if (!location.pathname.includes('transfers')) {
            sessionStorage.removeItem('transfer-form');
            sessionStorage.removeItem('luxpay-transfer-form');
        }

        if (!location.pathname.includes('templates')) {
            sessionStorage.removeItem('template-form');
            sessionStorage.removeItem('template-internal-form');
        }
    }, [location])

    useEffect(() => {
        dispatch(GetLimitsListThunk(token, chosenAccountTypeId))
    }, [])

    useEffect(() => {
        if (window.innerWidth <= 768) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }, [])

    const fetchIp = async () => {
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            return response.data.ip;
        } catch (error) {
            console.error(error);
            return null;
        }
    };

    useEffect(() => {
        if (refreshToken === true) {
            setIsOpenPopupTokenRefresh(true)
        } else {
            return
        }

    }, [refreshToken])

    useEffect(() => {
        dispatch(getUserAccountListThunk(token))
            .then((res) => {
                dispatch(setAccountsListTypesThunk(res.data));
            })

        const chosenAccount = accTypeList.find(acc => acc.id === chosenAccountTypeId)
        if (chosenAccount?.userAccountStatusLabel === 'Closed') {
            dispatch(LogoutThunk(sessionId, timezone, token))
                .then(() => {
                    navigate(DEACTIVATED_USER_PAGE);
                })
        }
    }, [location])

    const cancelRefreshToken = useCallback(() => {
        setIsOpenPopupTokenRefresh(false)
        dispatch(setTokenRefresh(false))
    }, [dispatch])

    useEffect(() => {
        let timeoutId: string | number | NodeJS.Timeout | undefined;

        const resetTimer = () => {
            clearTimeout(timeoutId);

            timeoutId = setTimeout(() => {
                if (isLogOutWhenUserWasInactive) {
                    handleLogout();
                }
            }, 10 * 60 * 1000);
        };

        const handleLogout = () => {
            setIsOpenPopupTokenRefresh(false)
            dispatch(setTokenRefresh(false))
            setIsInactiveMoreThanThirtyMinutes(true)
            dispatch(setDisabled(false))
        };

        resetTimer();

        window.addEventListener('mousemove', resetTimer);
        window.addEventListener('keydown', resetTimer);

        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener('mousemove', resetTimer);
            window.removeEventListener('keydown', resetTimer);
        };
    }, [isLogOutWhenUserWasInactive]);

    useLayoutEffect(() => {
        const checkIpChange = async () => {
            try {
                const newIp = await fetchIp();

                const savedIp = sessionStorage.getItem('currentIp') || '';

                if (newIp) {
                    if ((savedIp && newIp !== savedIp) && isLogOutWhenIpWasChanged) {
                        setIsContentHidden(false)

                        handleLogout();
                    }
                    sessionStorage.setItem('currentIp', newIp);
                    // setCurrentIp(newIp);
                }
            } catch (e) {
                console.log(e);
            }
        };

        const handleLogout = () => {
            setIsIpWasChanged(true);
        };

        const intervalId = setInterval(checkIpChange, 60 * 1000);

        checkIpChange()

        return () => {
            clearInterval(intervalId);
        };
    }, [isLogOutWhenIpWasChanged, token, clientId, accountId]);

    const initialValues = {
        companyName: '',
        firstName: '',
        lastName: '',
        type: accTypeList[0].accountType === 'personal' ? 'business' : 'personal',
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            dispatch(createNewTypeOfAccountThunk(token, values))
                .then((res) => {
                    setIsSuccessPopupOpen(true)
                    dispatch(getUserAccountListThunk(token))
                        .then((res) => {
                            dispatch(setAccountsListTypesThunk(res.data))
                        })
                    dispatch(GetAccountsListThunk(token, accountId, "EUR"))
                })
                .catch((e) => {
                    setIsErrorPopupOpen(true)
                })
                .finally(() => {
                    setIsModalForCreatingPersonalOpen(false)
                    setIsModalForCreatingBusinessOpen(false)
                })
        },
    });

    useEffect(() => {
        if (kycVerificationStatus === "Approved" && kycFormStatus === "Approved") {
            setIsMenuShow(true)
        } else {
            setIsMenuShow(false)
        }
    }, [kycVerificationStatus, kycFormStatus])

    const changeAccountType = useCallback((id: number) => {
        dispatch(setIsLoading(true))
        dispatch(setChosenAccountTypeIdThunk(id))
        dispatch(GetAccountDetailsByAccountTypeThunk(token, id)).then((result) => {
            if (result.data.flags.kycVerificationStatus === "Approved" && result.data.flags.kycFormStatus === "Approved") {
                navigate('/personal-account/accounts')
                dispatch(setIsLoading(false))
            } else {
                navigate('/personal-account/personal/settings')
                dispatch(setIsLoading(false))
            }
        })
    }, [dispatch, navigate, token])

    const resetToken = (e: any) => {
        e.preventDefault()
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        dispatch({type: 'STOP_REFRESH_TIMER'});
        dispatch(refreshTokenThunk(token, timezone, sessionId))
            .then((res) => {
                setIsOpenPopupTokenRefresh(false)
                setIsSuccessRefreshTokenPopUp(true)
                setIsSetRefreshToken({
                    userToken: res.userToken,
                    sessionId: res.sessionId
                });
                dispatch(setTokenRefresh(false))
                dispatch({type: 'START_REFRESH_TIMER'}); // перезапуск таймера
            })

            .catch((e) => {
                if (e.response.data === 'Invalid authorization data') {
                    setIsOpenPopupTokenRefresh(false);
                    dispatch(setTokenRefresh(false));
                    dispatch(setTokenState(false))
                } else {
                    setIsErrorPopupOpen(true)
                    setIsOpenPopupTokenRefresh(false);
                    dispatch(setTokenRefresh(false));
                }
            })
    }

    const closeAndRefreshToken = useCallback(() => {
        setIsSuccessRefreshTokenPopUp(false)

        dispatch(userSlice.actions.setToken(isSetRefreshToken.userToken))
        dispatch(userSlice.actions.setSessionId(isSetRefreshToken.sessionId))
    }, [dispatch, isSetRefreshToken.sessionId, isSetRefreshToken.userToken])

    const openAccountCreatingPopup = useCallback(() => {
        if (accTypeList[0].accountType === 'personal') {
            setIsModalForCreatingBusinessOpen(true)
        } else {
            setIsModalForCreatingPersonalOpen(true)
        }
    }, [accTypeList])

    return (
        <div>

            <Helmet>
                <title>LuxPay</title>
            </Helmet>

            <motion.div
                initial={{opacity: 0, scale: 1}}
                animate={{opacity: 1, scale: 1}}
                transition={{duration: 0.5}}
            >
                <CustomModal isModalOpen={isBugReportPopupActive} type={"info"}>
                    <BugReport
                        setIsModalOpen={setIsBugReportPopupActive}
                        setDocumentErrorModalText={setDocumentErrorModalText}
                        setIsDocumentErrorModalOpen={setIsDocumentErrorModalOpen}
                    />
                </CustomModal>

                <CustomModal isModalOpen={isDocumentErrorModalOpen} type="error" isNotify
                             setIsModalOpen={setIsDocumentErrorModalOpen}>
                    <div className={styles_popup.modal_content}>
                        <div className={styles_popup.popup_subtitle}>
                            <span className={styles_popup.error}>Error!</span> {documentErrorModalText}
                        </div>
                        <div className={styles_popup.popup_button_block}>
                            <MyBtn title={'Ok'} isPersonalAccountBtn medium buttonType="error"
                                   onClick={() => setIsDocumentErrorModalOpen(false)}/>
                        </div>
                    </div>
                </CustomModal>

                <CustomModal isModalOpen={isSuccessPopupOpen} isNotify setIsModalOpen={setIsSuccessPopupOpen}>
                    <div className={styles_popup.modal_content}>
                        <div className={styles_popup.popup_subtitle}>
                            <span className={styles_popup.success}>Success!</span> Your request has been sent
                            successfully.
                        </div>
                        <div className={styles_popup.popup_button_block}>
                            <MyBtn title={'Ok'} isPersonalAccountBtn medium
                                   onClick={() => setIsSuccessPopupOpen(false)}/>
                        </div>
                    </div>
                </CustomModal>

                <CustomModal isModalOpen={isSuccessRefreshTokenPopupOpen} isNotify
                             setIsModalOpen={setIsSuccessRefreshTokenPopUp}>
                    <div className={styles_popup.modal_content}>
                        <div className={styles_popup.popup_subtitle}>
                            <span className={styles_popup.success}>Success!</span> Your session has been extended by 1
                            hour.
                        </div>
                        <div className={styles_popup.popup_button_block}>
                            <MyBtn title={'Ok'} isPersonalAccountBtn medium
                                   onClick={() => closeAndRefreshToken()}/>
                        </div>
                    </div>
                </CustomModal>

                <CustomModal type="error" isNotify isModalOpen={isErrorPopupOpen} setIsModalOpen={setIsErrorPopupOpen}>
                    <div className={styles_popup.modal_content}>
                        <div className={styles_popup.popup_subtitle}>
                            <span className={styles_popup.error}>Failed!</span> Your request was rejected. Please try
                            again.
                        </div>
                        <div className={styles_popup.popup_button_block}>
                            <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => {
                                setIsErrorPopupOpen(false)
                            }}/>
                        </div>
                    </div>
                </CustomModal>

                <CustomModal isModalOpen={isModalForCreatingPersonalOpen} type={"confirm"}>
                    <form onSubmit={formik.handleSubmit}>
                        <div className={styles.popup_content}>
                            <img src={notify} alt=""/>
                            <div className={styles.popup_title_create_account}>
                                To add personal account please enter required data
                            </div>
                            <div className={styles.input_wrapper}>
                                <span className={styles.input_label}>First Name</span>
                                <MyInput
                                    name={'firstName'}
                                    id={'firstName'}
                                    touched={formik.touched.firstName}
                                    isError={formik.errors.firstName}
                                    onChange={formik.handleChange}
                                />
                                {formik.errors.firstName && <div className={styles.error_text}>
                                    {formik.errors.firstName}
                                </div>}
                            </div>
                            <div className={styles.input_wrapper}>
                                <span className={styles.input_label}>Last Name</span>
                                <MyInput
                                    name={'lastName'}
                                    id={'lastName'}
                                    touched={formik.touched.lastName}
                                    isError={formik.errors.lastName}
                                    onChange={formik.handleChange}
                                />
                                {formik.errors.lastName && <div className={styles.error_text}>
                                    {formik.errors.lastName}
                                </div>}
                            </div>
                            <div className={s.checkboxes}>
                                <div className={s.checkbox}>
                                    <CustomCheckbox1
                                        name={"checkbox1"}
                                        checked={checkboxState.checkbox1}
                                        onChange={(e: any) => setCheckboxState({
                                            ...checkboxState,
                                            checkbox1: e.target.checked
                                        })}
                                    />
                                    <div className={s.checkbox_text}>
                                        I agree to my personal data being processed in accordance with the
                                        <a href='/privacy_policy' className={s.link}>Privacy Policy</a>
                                    </div>
                                </div>
                                <div className={s.checkbox}>
                                    <CustomCheckbox1
                                        name={"checkbox2"}
                                        checked={checkboxState.checkbox2}
                                        onChange={(e: any) => setCheckboxState({
                                            ...checkboxState,
                                            checkbox2: e.target.checked
                                        })}
                                    />
                                    <div className={s.checkbox_text}>
                                        I agree with the
                                        {/*reverse it , because user create opposite account*/}
                                        <a href={accTypeList[0].accountType === 'personal' ? '/terms-and-conditions/business' : '/terms-and-conditions/personal'}
                                           className={s.link}>
                                            Terms of use of LuxPay
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.popup_button_wrapper}>
                                <div className={styles.button_block}>
                                    <TransparentButton
                                        title={"Back"}
                                        medium
                                        isPersonalAccountBtn buttonType={"confirm"}
                                        icon={<Icon component={() => <Back/>} rev={undefined}/>}
                                        onClick={() => setIsModalForCreatingPersonalOpen(false)}/>
                                </div>
                                <div className={styles.button_block}>
                                    <MyBtn
                                        type='submit'
                                        title={"Confirm"}
                                        isPersonalAccountBtn
                                        buttonType={"confirm"}
                                        localDisable={!checkboxState.checkbox1 || !checkboxState.checkbox2}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </CustomModal>

                <CustomModal isModalOpen={isModalForCreatingBusinessOpen} type={"confirm"}>
                    <form onSubmit={formik.handleSubmit}>
                        <div className={styles.popup_content}>
                            <img src={notify} alt=""/>
                            <div className={styles.popup_title_create_account}>
                                To add business account please enter required data
                            </div>
                            <div className={styles.input_wrapper}>
                                <span className={styles.input_label}>Company name</span>
                                <MyInput
                                    name={'companyName'}
                                    id={'companyName'}
                                    touched={formik.touched.companyName}
                                    isError={formik.errors.companyName}
                                    onChange={formik.handleChange}
                                />
                                {formik.errors.companyName && <div className={styles.error_text}>
                                    {formik.errors.companyName}
                                </div>}
                            </div>
                            <div className={s.checkboxes}>
                                <div className={s.checkbox}>
                                    <CustomCheckbox1
                                        name={"checkbox1"}
                                        checked={checkboxState.checkbox1}
                                        onChange={(e: any) => setCheckboxState({
                                            ...checkboxState,
                                            checkbox1: e.target.checked
                                        })}
                                    />
                                    <div className={s.checkbox_text}>
                                        I agree to my personal data being processed in accordance with the
                                        <a href='/privacy_policy' className={s.link}>Privacy Policy</a>
                                    </div>
                                </div>
                                <div className={s.checkbox}>
                                    <CustomCheckbox1
                                        name={"checkbox2"}
                                        checked={checkboxState.checkbox2}
                                        onChange={(e: any) => setCheckboxState({
                                            ...checkboxState,
                                            checkbox2: e.target.checked
                                        })}
                                    />
                                    <div className={s.checkbox_text}>
                                        I agree with the
                                        {/*reverse it , because user create opposite account*/}
                                        <a href={accTypeList[0].accountType === 'personal' ? '/terms-and-conditions/business' : '/terms-and-conditions/personal'}
                                           className={s.link}>
                                            Terms of use of LuxPay
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.popup_button_wrapper}>
                                <div className={styles.button_block}>
                                    <TransparentButton
                                        title={"Back"}
                                        medium
                                        isPersonalAccountBtn buttonType={"confirm"}
                                        icon={<Icon component={() => <Back/>} rev={undefined}/>}
                                        onClick={() => setIsModalForCreatingBusinessOpen(false)}/>
                                </div>
                                <div className={styles.button_block}>
                                    <MyBtn
                                        title={"Confirm"}
                                        isPersonalAccountBtn
                                        buttonType={"confirm"}
                                        type={"submit"}
                                        localDisable={!checkboxState.checkbox1 || !checkboxState.checkbox2}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </CustomModal>

                <CustomModal isModalOpen={!isTokenValid} type={"error"} isBlur>
                    <div className={styles_popup.block_center}>
                        <img src={icon_close_circle} alt=""/>
                    </div>
                    <div className={styles_popup.popup_title}>
                        Oops!
                    </div>
                    <div className={styles_popup.popup_subtitle}>
                        Your session time has been expired. Please login once again.
                    </div>
                    <div className={styles_popup.popup_button_wrapper}>
                        <div className={styles_popup.popup_button_block}>
                            <MyBtn title={"Ok"} isPersonalAccountBtn buttonType={"error"}
                                   onClick={() => handleLogout()}/>
                        </div>
                    </div>
                </CustomModal>

                <CustomModal isModalOpen={isInactiveMoreThanThirtyMinutes} type={"confirm"} isBlur>
                    <div className={styles.popup_title}>
                        Oops!
                    </div>
                    <div className={styles.popup_subtitle}>
                        You was inactive more than 10 minutes. Please login once again.
                    </div>
                    <div className={styles.popup_button_wrapper}>
                        <div className={styles.button_block}>
                            <MyBtn title={"Ok"} isPersonalAccountBtn buttonType={"confirm"}
                                   onClick={() => handleLogout()}/>
                        </div>
                    </div>
                </CustomModal>

                <CustomModal isModalOpen={isIpWasChanged} type={"confirm"} isBlur>
                    <div className={styles.popup_title}>
                        Oops!
                    </div>
                    <div className={styles.popup_subtitle}>
                        Your IP was changed. Please login once again.
                    </div>
                    <div className={styles.popup_button_wrapper}>
                        <div className={styles.button_block}>
                            <MyBtn title={"Ok"} isPersonalAccountBtn buttonType={"confirm"}
                                   onClick={() => handleLogout()}/>
                        </div>
                    </div>
                </CustomModal>

                <CustomModal isModalOpen={IsOpenPopupTokenRefresh && isTokenValid} type={"info"}>
                    <div className={styles.popup_title}>
                        Session About to Expire!
                    </div>
                    <div className={styles.popup_subtitle}>
                        Your session will expire in 10 minutes. Would you like to extend it?
                    </div>
                    <div className={styles.popup_button_wrapper}>
                        <div className={styles.button_block}>
                            <TransparentButton
                                title={"Cancel"}
                                isPersonalAccountBtn
                                buttonType={"info"}
                                medium
                                onClick={cancelRefreshToken}
                            />
                        </div>
                        <div className={styles.button_block}>
                            <MyBtn
                                title={"Confirm"}
                                isPersonalAccountBtn
                                buttonType={"info"}
                                onClick={(e) => resetToken(e)}
                            />
                        </div>
                    </div>
                </CustomModal>

                <CustomModalContactContainer setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen}/>

                <div className={s.wrapper_desktop}>
                    <div className={s.test_grid}>
                        <div className={s.side_menu}>
                            <div className={s.fixed}>
                                <SideMenu isMenuShow={isMenuShow} handleLogout={handleLogout}/>
                            </div>
                        </div>
                        <div className={s.main_content}>
                            <div className={s.header}>
                                <div className={s.left}>
                                    <div className={s.icons_block}>
                                        <div className={s.round} onClick={() => setIsModalOpen(true)}>
                                            <div className={s.mail}></div>
                                        </div>
                                        {/*<div className={s.bug_report_btn}>*/}
                                        {/*    <MyBtn*/}
                                        {/*        title={"Bug report"}*/}
                                        {/*        isPersonalAccountBtn*/}
                                        {/*        icon={iconPlus}*/}
                                        {/*        onClick={() => setIsBugReportPopupActive(true)}*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                    </div>
                                </div>
                                <div className={s.right}>
                                    <div className={isActive ? s.userRoundActive : s.userRound}
                                         onClick={() => {
                                             setIsActive(!isActive)
                                         }}
                                         ref={ref2}
                                    >
                                        <div className={s.always_show}>
                                            <div className={s.user_typography}>
                                                <div><p className={s.name}>{firstName} {lastName} {companyName}</p>
                                                </div>
                                                <div><p className={s.id}>ID: {clientId}</p></div>
                                            </div>
                                            <div className={s.user}></div>
                                        </div>

                                        <div
                                            ref={ref}
                                            className={isActive ? s.openDetails : s.openDetailsHidden}
                                        >
                                            <div>
                                                {
                                                    accTypeList.map((acc) =>
                                                        <div className={s.checkbox_block} key={acc.id}>
                                                            {acc.userAccountStatusLabel !== "Active" &&
                                                                <span className={classnames(
                                                                    s.inactive_notify,
                                                                    acc.userAccountStatusLabel === "Closed" && s.inactive_notify_closed,
                                                                    acc.userAccountStatusLabel === "Suspended" && s.inactive_notify_suspended
                                                                )}>
                                                                    Account is {acc.userAccountStatusLabel}
                                                                </span>}
                                                            <button className={s.flex_label} onClick={(e) => {
                                                                e.preventDefault()
                                                                if (acc.userAccountStatusLabel !== "Closed") {
                                                                    changeAccountType(acc.id)
                                                                }
                                                            }}>
                                                                <CustomCheckbox
                                                                    handleChange={() => {
                                                                    }}
                                                                    id={acc.accountType}
                                                                    name={acc.accountType}
                                                                    isChecked={chosenAccountTypeId === acc.id}
                                                                />
                                                                <span
                                                                    className={classnames(s.account_type_label, acc.userAccountStatusLabel === "Closed" && s.inactive_account)}>
                                                                        {acc.accountType === 'personal' ? 'Personal account' : 'Business account'}
                                                                    </span>
                                                            </button>
                                                        </div>
                                                    )
                                                }
                                                {accTypeList.length === 1 &&
                                                    <div className={s.checkbox_block}>
                                                        <label className={s.flex_label}
                                                               onClick={() => openAccountCreatingPopup()}>
                                                            <img src={plus} alt="" className={s.icon_plus}/>
                                                            <span className={s.account_type_label}>
                                                                    {
                                                                        accTypeList[0].accountType === 'personal'
                                                                            ? 'Add business account'
                                                                            : 'Add personal account'
                                                                    }
                                                                </span>
                                                        </label>
                                                    </div>
                                                }
                                            </div>
                                            <div className={s.logout_block}>
                                                <div className={s.logout_row} onClick={() => handleLogout()}>
                                                    <div className={s.img_logout}></div>
                                                    <div className={s.text}>Logout</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>
                            {isLoading && <Loader/>}
                            <main className={s.main_wrapper}
                                  style={{
                                      opacity: (isContentHidden || isLoading) ? 0 : 1,
                                      display: (isContentHidden || isLoading) ? 'none' : 'block'
                                  }}>
                                <Outlet/>
                            </main>
                        </div>
                    </div>
                </div>
                {isMobile &&
                    <div className={s.wrapper_mobile}>
                        <Space direction="vertical" style={{width: '100%', position: "relative", background: '#F6F9FF'}}
                               size={[0, 0]}>
                            <Layout style={{background: '#F6F9FF'}}>
                                <Sider className={s.sider} style={siderStyle} width={240}>
                                    <div>
                                        <Link to="/">
                                            <img src={logo} alt="" className={s.logo}/>
                                        </Link>
                                    </div>
                                    {
                                        isMenuShow
                                            ? <></>
                                            : <div>
                                                <div className={s.links_title}>services</div>

                                                <NavLink to={`/personal-account/accounts`}
                                                         className={({isActive}) => classnames(s.nav_item, isActive ? "active" : 'inactive')}>
                                                    <div className="img_block">
                                                        <div className="img_accounts"></div>
                                                    </div>
                                                    <div className="text_block">
                                                        Accounts
                                                    </div>

                                                </NavLink>
                                                <NavLink to={`/personal-account/transfers`}
                                                         className={({isActive}) => classnames(s.nav_item, isActive ? "active" : 'inactive')}>
                                                    <div className="img_block">
                                                        <div className="img_transfers"></div>
                                                    </div>
                                                    <div className="text_block">
                                                        Transfers
                                                    </div>
                                                </NavLink>
                                                <NavLink to={`/personal-account/templates`}
                                                         className={({isActive}) => classnames(s.nav_item, isActive ? "active" : 'inactive')}>
                                                    <div className="img_block">
                                                        <div className="img_templates"></div>
                                                    </div>
                                                    <div className="text_block">
                                                        Templates
                                                    </div>
                                                </NavLink>
                                                {/*<NavLink to={`/personal-account/currency`}*/}
                                                {/*         className={({isActive}) => classnames(s.nav_item, isActive ? "active" : 'inactive')}>*/}
                                                {/*    <div className="img_block">*/}
                                                {/*        <div className="img_currency"></div>*/}
                                                {/*    </div>*/}
                                                {/*    <div className="text_block">*/}
                                                {/*        Currency*/}
                                                {/*    </div>*/}
                                                {/*</NavLink>*/}
                                            </div>

                                    }

                                    <div className={classnames(s.links_title, s.services_block)}>Account</div>

                                    <NavLink to={`/personal-account/security`}
                                             className={({isActive}) => classnames(s.nav_item, isActive ? "active" : 'inactive')}>
                                        <div className="img_block">
                                            <div className="img_security"></div>
                                        </div>
                                        <div className="text_block">
                                            Security
                                        </div>
                                    </NavLink>
                                    <NavLink to={`/personal-account/${accType}/settings`}
                                             className={({isActive}) => classnames(s.nav_item, isActive ? "active" : 'inactive')}>
                                        <div className="img_block">
                                            <div className="img_settings"></div>
                                        </div>
                                        <div className="text_block">
                                            Settings
                                        </div>
                                    </NavLink>

                                    <div className={classnames('inactive')} onClick={() => handleLogout()}>
                                        <div className="img_block">
                                            <div className="img_logout"></div>
                                        </div>
                                        <div className={s.logout}>Logout</div>
                                    </div>
                                </Sider>
                                <Layout>
                                    {<div className={s.header_wrapper}>
                                        <Header style={headerStyle}>
                                            <div className={s.left}>
                                                <div className={s.icons_block}>
                                                    <div className={s.round} onClick={() => setIsModalOpen(true)}>
                                                        <div className={s.mail}></div>
                                                    </div>
                                                    {/*<div className={s.round}>*/}
                                                    {/*    <img className={s.icon_point} src={icon_point} alt=""/>*/}
                                                    {/*    <div className={s.chat}></div>*/}
                                                    {/*</div>*/}
                                                </div>
                                            </div>
                                            <div className={s.right}>
                                                <div className={s.user_round}>
                                                    {firstName?.slice(0, 1)}{lastName?.slice(0, 1)}{companyName?.slice(0, 1)}
                                                </div>
                                            </div>
                                        </Header>
                                    </div>}
                                    {isLoading && <Loader/>}
                                    <div style={{opacity: (isContentHidden || isLoading) ? 0 : 1}}>
                                        <Content style={contentStyleMobile}>
                                            <Outlet/>
                                        </Content>
                                    </div>
                                </Layout>
                            </Layout>
                        </Space>
                    </div>
                }
            </motion.div>
        </div>
    );
};

export default PersonalAccount;
